<template>
  <div class="game">
    <bird-playing-field></bird-playing-field>
    <bird-players></bird-players>
  </div>
</template>

<script>
  import PlayingField from "./PlayingField.vue"
  import Players from "./Players.vue"

  export default {
    components: {
      birdPlayingField: PlayingField,
      birdPlayers: Players
    }
  }
</script>
<style scoped>
.game {
  display:flex;
  margin: 1em;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Game.vue